import React from 'react';
import { ShieldCheck, Lock, HeartHandshake } from 'lucide-react';
interface TrustBadgeProps {
  variant?: 'light' | 'dark';
}
export function TrustBadge({
  variant = 'light'
}: TrustBadgeProps) {
  const isDark = variant === 'dark';
  const textColor = isDark ? 'text-white' : 'text-slate-700';
  const subTextColor = isDark ? 'text-slate-300' : 'text-slate-500';
  return <div className={`flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 py-6 ${isDark ? 'bg-slate-800/50' : 'bg-slate-50'} rounded-xl border ${isDark ? 'border-slate-700' : 'border-slate-100'}`} data-id="element-53">
      <div className="flex items-center gap-3" data-id="element-54">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-55">
          <ShieldCheck className="w-6 h-6 text-green-600" data-id="element-56" />
        </div>
        <div className="text-left" data-id="element-57">
          <p className={`font-bold text-sm ${textColor}`} data-id="element-58">Compra Segura</p>
          <p className={`text-xs ${subTextColor}`} data-id="element-59">
            Tus datos están protegidos
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3" data-id="element-60">
        <div className="bg-blue-100 p-2 rounded-full" data-id="element-61">
          <Lock className="w-6 h-6 text-blue-600" data-id="element-62" />
        </div>
        <div className="text-left" data-id="element-63">
          <p className={`font-bold text-sm ${textColor}`} data-id="element-64">Acceso Inmediato</p>
          <p className={`text-xs ${subTextColor}`} data-id="element-65">
            Llega a tu email al instante
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3" data-id="element-66">
        <div className="bg-orange-100 p-2 rounded-full" data-id="element-67">
          <HeartHandshake className="w-6 h-6 text-orange-600" data-id="element-68" />
        </div>
        <div className="text-left" data-id="element-69">
          <p className={`font-bold text-sm ${textColor}`} data-id="element-70">Soporte Humano</p>
          <p className={`text-xs ${subTextColor}`} data-id="element-71">
            Te ayudamos si tenés dudas
          </p>
        </div>
      </div>
    </div>;
}